<div class="drawflow-main position-relative action-{{action}} mode-edit-{{edit}}" id="drawflow-{{drawflowId}}"
    width="100%">
</div>

<div class="drawflow-button-container action-{{action}}">
    <div class="bar-zoom">
        <i class="mio vam mr-2" (click)="rearrangeFlow();" style="cursor: pointer;">compare_arrows</i>
        <i class="mio vam mr-2" (click)="onZoomOut()" style="cursor: pointer;">zoom_out</i>
        <i class="mio vam mr-2" (click)="onZoomReset()" style="cursor: pointer;">search</i>
        <i class="mio vam" (click)="onZoomIn()" style="cursor: pointer; width: 24px;">zoom_int</i>
    </div>
</div>
